import { render, staticRenderFns } from "./CastrVideoPlayer.vue?vue&type=template&id=1305e9c6"
import script from "./CastrVideoPlayer.vue?vue&type=script&lang=js"
export * from "./CastrVideoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports